import React from "react";

const UTMParams = ({ rowData }) => {
  const {
    utm_source,
    utm_medium,
    utm_content,
    utm_term,
    utm_campaign,
    ga_medium,
    ga_campaignid,
    // gclid,
    ga_source,
  } = rowData || {};

  return (
    <div className="mini-tb-container mt30">
      <ul className="tb-section tb-section-1">
        <li className="tb-section-item tb-section-item-lable">UTM Source</li>
        <li className="tb-section-item tb-section-item-lable">UTM Medium</li>
        <li className="tb-section-item tb-section-item-lable">UTM Campaign</li>
        <li className="tb-section-item tb-section-item-lable">UTM Content</li>
        <li className="tb-section-item tb-section-item-lable">UTM Term</li>
      </ul>
      <ul className="tb-section tb-section-2">
        <li className="tb-section-item tb-section-item-lable-value">
          {utm_source || ga_source || "NA"}
        </li>
        <li className="tb-section-item tb-section-item-lable-value">
          {utm_medium || ga_medium || "NA"}
        </li>
        <li className="tb-section-item tb-section-item-lable-value">
          {utm_campaign || ga_campaignid || "NA"}
        </li>
        <li className="tb-section-item tb-section-item-lable-value">
          {utm_content || "NA"}
        </li>
        <li className="tb-section-item tb-section-item-lable-value">
          {utm_term || "NA"}
        </li>
      </ul>
    </div>
  );
};

export default UTMParams;